import * as Actions from '../../Store/Actions/FormPessoaActions';

const initialState = {
    info: null,
    error: null,
    warning: null,
    isFuncionario: false,
    tipos: null
};

const FormPessoaReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.FORMPESSOA_FUNCIONARIO_INFO:
            {
                return {
                    ...state,
                    isFuncionario: action.data,
                    info: action.payload
                }
            }
        case Actions.FORMPESSOA_INFO:
            {
                return {
                    ...state,
                    info: action.payload
                }
            }
        case Actions.FORMPESSOA_ERROR:
            {
                return {
                    ...state,
                    error: action.payload
                }
            }
        case Actions.FORMPESSOA_WARNING:
            {
                return {
                    ...state,
                    warning: action.payload
                }
            }
        case Actions.GET_FORMPESSOA_TIPOS:
            {
                return {
                    ...state,
                    tipos: action.payload
                }
            }
        default:
            {
                return state;
            }
    }
};

const reducer = FormPessoaReducer;
export default reducer;
